import { type ReactNode } from 'react';
import { Button, Step, Stepper } from '@repo/design-system-kit';
import { IconCrossOutlined } from '@repo/monochrome-icons';
import { useIntl } from 'react-intl';
import cx from 'clsx';
import styles from './flow-header-bar.module.css';

export interface FlowHeaderBarWithoutStepsProps {
  title: string;
  onClose: () => void;
}

export interface FlowHeaderBarWithStepsProps extends FlowHeaderBarWithoutStepsProps {
  steps: string[];
  currentStep: number;
  lastCompletedStep?: number;
  onStepClick: (stepIndex: number) => void;
}

export function FlowHeaderBar(
  props: FlowHeaderBarWithoutStepsProps | FlowHeaderBarWithStepsProps
): ReactNode {
  const { formatMessage } = useIntl();

  const { title, onClose } = props;
  const hasSteps = 'steps' in props;

  return (
    <header className={styles.header} data-test-flow-header="">
      <h2 className={cx('heading-section', styles.title)} data-test-flow-header-title="">
        {title}
      </h2>
      <div className={styles.steps}>
        {hasSteps ? (
          <Stepper
            currentStep={props.currentStep}
            lastCompletedStep={props.lastCompletedStep}
            onStepClick={props.onStepClick}
          >
            {props.steps.map(step => (
              <Step key={step} label={step} />
            ))}
          </Stepper>
        ) : null}
      </div>
      <div className={styles.actions}>
        <Button
          aria-label={formatMessage({ id: 'generic.close.cta' })}
          className={styles.button}
          data-test-flow-header-close-button=""
          iconOnly
          onPress={onClose}
          size="large"
          variant="tertiary"
        >
          <IconCrossOutlined />
        </Button>
      </div>
    </header>
  );
}
